import React, { useEffect, useReducer, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { getComplexPath } from 'shared/routes/building';
import { getComplexToolsPath } from 'shared/routes/networking';
import CardActionButtons from 'features/networking/ui/CardActionButtons';
import { TabbedCard } from 'shared/components/abstract/interactables';
import { getComplex } from 'shared/api/complexes';
import { useRequest } from 'shared/hooks';
import { dataReducer, DataReducerActions, initialDataReducerState } from 'shared/reducers';
import NasPanel from 'features/networking/complex/NasPanel';
import VlansPanel from 'features/networking/complex/VlansPanel';
import ZonesPanel from 'features/networking/complex/ZonesPanel';

export const initialVLANState = {
  nas: {
  },
  nas_profile: {
    ip: '',
  },
};

/**
 * @param {Object} props
 * @param {string} props.id - Complex ID
 */
function ComplexCard({ id }) {
  const { search } = useLocation();
  const history = useHistory();
  const { request } = useRequest();

  const [state, dispatch] = useReducer(dataReducer, initialDataReducerState);
  const [updateCount, setUpdateCount] = useState(0);
  const triggerUpdate = () => setUpdateCount(updateCount + 1);

  const {
    data: complex,
    dirty,
  } = state;

  useEffect(() => {
    if (id && id > 0) {
      (async () => {
        const result = await request(getComplex(id, '?expand=buildings&expand=nas&expand=units'));
        if (result) {
          dispatch({ action: DataReducerActions.set, payload: result });
        }
      })();
    }
  }, [id, request, updateCount]);

  if (complex === undefined) return null;

  const tabs = [
    {
      label: 'Nas/VTR',
      content: <NasPanel
        complex={complex}
        triggerUpdate={triggerUpdate}
        updateCount={updateCount}
      />,
    },
    {
      label: 'Vlans',
      content: <VlansPanel state={state} dispatch={dispatch} />,
    },
    {
      label: 'Zones',
      content: <ZonesPanel
        complex={complex}
        triggerUpdate={triggerUpdate}
        updateCount={updateCount}
      />,
    },
  ];

  const close = () => {
    if (dirty) {
      dispatch({ action: DataReducerActions.clear });
    } else {
      const searchParams = new URLSearchParams(search);
      history.push(getComplexToolsPath(searchParams
        .getAll('complex_id')
        .filter((bId) => bId !== id.toString())));
    }
  };

  return (
    <TabbedCard
      dirty={dirty}
      optionsContentArray={tabs}
      title={(
        <Link
          sx={{ fontSize: '5px' }}
          title="Link to Complex"
          to={getComplexPath(id)}
        >
          {complex?.name}
        </Link>
      )}
      titleAction={(
        <CardActionButtons
          closeDispatchFunc={close}
        />
      )}
    />
  );
}

export default ComplexCard;
